import React from 'react';
import memoize from 'memoize-one';
import { AttendanceUpdateActionBtns } from '../index';
import ApprovementStatus from '../DatatableColumns/ApprovementStatus';

const columns = memoize((clickHandler = true) => [
  {
    name: 'FECHA',
    selector: 'real_marking_date',
    sortable: true,
    grow: 0.5,
    center: true,
  },
  {
    name: 'TURNO',
    selector: 'shift',
    cell: item => item.shift?.name,
    sortable: true,
    grow: 2,
    center: false,
  },
  {
    name: 'HORA',
    selector: 'time',
    cell: item => item.complete_parsed_time,
    sortable: true,
    grow: 1,
    center: true,
  },
  {
    name: 'TIPO',
    selector: 'time_type',
    cell: item => item.translated_time_type,
    sortable: true,
    grow: 1,
    center: true,
  },
  {
    name: 'MODALIDAD',
    selector: 'translated_device_type',
    cell: item =>
      item.translated_device_type || item.translated_marking_type,
    sortable: false,
    grow: 1,
    center: true
  },
  {
    name: 'ESTADO',
    selector: 'status',
    cell: item => <ApprovementStatus status={item.status} />,
    sortable: true,
    grow: 1,
    center: true,
  },
  {
    name: 'ACCIONES',
    cell: item => (
      <AttendanceUpdateActionBtns
        item={item}
        resource="Attendance"
        clickHandler={clickHandler}
        withEdit={false}
        withDestroy={false}
        withShow
      />
    ),
    button: true,
    ignoreRowClick: true,
    allowOverflow: false,
    minWidth: '110px',
    grow: 0,
    center: true,
  },
]);

export default columns;
